import slugify from '../slugify';
import { ProjectUrlFunction } from './types';

const getProjectUrl: ProjectUrlFunction = ({
  id,
  commune = 'no-informado',
  title
}) => {
  const propertySlug = slugify(title);
  const locationSlug = slugify(commune);

  return `/proyecto/venta/${locationSlug}/${id}-${propertySlug}`;
};

export default getProjectUrl;
